import React from "react";
import stepIcon1 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_1.svg";
import stepIcon2 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_2.svg";
import stepIcon3 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_3.svg";
import stepIcon4 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_4.svg";
import { LandingPageWrapper } from "./_styles/LandingPageWrapper";

import LoanExpired from "../../assets/svg/EPL_think_svg/loan_expired.svg";
import { isValidSearchParams } from "../../shared/validations/SearchParams.js";
import { InvalidURLModal } from "../other-pages/Modals/AllModal";

import Button from "../../components/core/EPL_Button_Think";
// import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import carouselImage1 from "../../assets/images/EPL_think_images/Landing_Page/01_Travel.png";
import carouselBanner1 from "../../assets/images/EPL_think_images/Landing_Page/01_banner.png";
import Carousel from "../../components/advance/Carousel";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import Accordion from "./Accordion";
// import GetCustomerDetailsContext from "../../App"

// const LandingPageCarousel = ({ index, history, location }) => {
const LandingPageCarousel = ({ index, navigate, location }) => {
  const images = [carouselBanner1];
  const carouselMessage = [
    "Tick off all the places on your travel bucket list",
    "Achieve your aspirations without any setbacks!",
    "Give your home the elegant transormation you desire",
    "Your dreams of having an extravagant wedding can be a reality!",
  ];
  const source = location.pathname.split("/")[1]; // "epl"

  return (
    <>
      {/* <div className="index-carousel-message">
        Need an instant Personal Loan to Travel?
      </div>
      <div className="index-carousel-cta">
        <button
          onClick={() => {
            // history.push({
            //   pathname: `/login`,
            //   search: location.search,
            // });
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "",
            });
            // console.log("stage: ", customerDetails.stage);
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
              state: {
                customerDetails: customerDetails,
              },
            });
          }}
        >
          Apply
        </button>
      </div> */}
      <Carousel
        images={images}
        carouselMessage={carouselMessage}
        index={index}
        navigate={navigate}
        source={source}
      />
    </>
  );
};

const EPL = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const [showInvalidURLModal, setShowInvalidURLModal] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const dsa_hash = searchParams.get("dsa_hash");
	const [urlParams, setUrlParams] = useState("");

  useEffect(() => {
    if (isValidSearchParams() && searchParams.get("dsa_hash")) {
      setUrlParams(window.location.search);
    } else {
      setShowInvalidURLModal(true);
    }
  }, []);

  
  const source = location.pathname.split("/")[1]; // "epl"

  const FloatingButton = ({ source }) => (
    <>
      <div
        style={{
          display: "flex",
          position: "fixed",
          bottom: "10px",
          justifyContent: "center",
          zIndex: 5,
          justifyContent: "center",
          width: "100%",
          pointerEvents: "none",
        }}
      >
        {/* <Button
          id="cta-button"
          className="cta-button"
          style={{
            pointerEvents: "all",
          }}
          onClick={() => {
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "",
            });
            // console.log("stage: ", customerDetails.stage);
            // console.log("route: ", route);
			console.log(searchParams.get("dsa_hash"));
			// sessionStorage.setItem("dsa_hash", dsa_hash);

            if (dsa_hash) {
              const url = `${route}?dsa_hash=${dsa_hash}`;
				// console.log(searchParams.get("dsa_hash"));
              sessionStorage.setItem("dsa_hash", dsa_hash);
			  console.log(sessionStorage.getItem("dsa_hash"));
              navigate(url, {
                replace: true,
                // state: {
                // 	customerDetails: customerDetails,
                // },
              });
            } else {
              const url = `${route}`;
              navigate(url, {
                replace: true,
                // state: {
                // 	customerDetails: customerDetails,
                // },
              });
            }
          }}
          text={"Apply Now"}
        /> */}
      </div>
    </>
  );

  return (
		<>
			<FloatingButton source={source} />
			<InvalidURLModal
				isOpen={showInvalidURLModal}
				modalImage={LoanExpired}
				onClose={() => {}}
			/>
			<LandingPageWrapper>
				<div className="index-layout">
					{/* <div className="index-title-container">
						Instant Personal Loan for Salaried Employees
					</div> */}
					<div className="index-carousel">
						<LandingPageCarousel
							index={0}
							// history={history}
							navigate={navigate}
							location={location}
						/>
					</div>
					<div className="index-description">
						<span>
							Get a <span>Personal Loan</span> up to{" "}
							<span>&#8377;10,00,000</span> in four steps
						</span>
					</div>
					<div className="index-steps">
						<span>
							<div className="index-steps-icon-container">
								<img src={stepIcon1} />
							</div>
							<div className="index-steps-line index-steps-line-first"></div>
							<span>Enter Personal & Professional Details</span>
						</span>
						<span>
							<div className="index-steps-icon-container">
								<img src={stepIcon2} />
							</div>
							<div className="index-steps-line"></div>
							<span>Choose loan amount and tenure</span>
						</span>
						<span>
							<div className="index-steps-icon-container">
								<img src={stepIcon3} />
							</div>
							<div className="index-steps-line"></div>
							<span>
								Verify your loan agreement and provide an
								e-consent
							</span>
						</span>
						<span>
							<div className="index-steps-icon-container">
								<img src={stepIcon4} />
							</div>
							<div className="index-steps-line index-steps-line-last"></div>
							<span>Get an instant loan disbursal</span>
						</span>
					</div>
					{/* <div className="index-documents-card">
						<h2>Keep the following documents ready</h2>
						<div className="index-documents-list">
							<ul>
								<li>PAN and Aadhaar number</li>
								<li>6 month Salary Account Bank Statement</li>
								<li>Bank Details for Loan disbursement</li>
							</ul>
							<img src={moneyImg} height="100" width="100" />
						</div>
					</div> */}
					<div className="accordion-container">
						<Accordion
							title="Personal Loan FAQs"
							headerClassName="mainHeader"
							contentClassName="mainContent"
							content={
								<>
									<Accordion
										title="How can I apply?"
										content={
											<>
												You can apply for the Personal
												Loan by following the steps
												given below:
												<li>
													Open the digital journey
													mobile web URL link
												</li>
												<li>
													Login using your Mobile
													Number through OTP based
													authentication process
												</li>
												<li>
													Enter your Personal Details
													and Professional Details
												</li>
												<li>
													Choose your desired Amount
													and Tenure
												</li>
												<li>Complete e-KYC process</li>
												<li>
													Check and Confirm Bank
													Details
												</li>
												<li>
													Register for the eNACH
													mandate
												</li>
												<li>
													Provide Reference Details
												</li>
												<li>
													Accept the digital loan
													agreement Voila! Your loan
													will be disbursed to your
													account
												</li>
											</>
										}
									/>
									<Accordion
										title="What are the minimum and maximum loan amounts?"
										content={
											<>
												Minimum loan amount that can be
												availed is ₹50,000 & Maximum
												loan amount is ₹10 Lakhs. The
												maximum amount can differ from
												person to person based on the
												eligibility criteria.
											</>
										}
									/>
									<Accordion
										title="What are the eligibility requirements for availing Personal Loan?"
										content={
											<>
												You should be meeting internal
												policy criterion for Personal
												Loan.
											</>
										}
									/>
									<Accordion
										title="What is the tenure of a personal loan?"
										content={
											<>
												The repayment schedule varies up
												to 60 months depending on the
												loan amount chosen. You will
												have flexibility to choose your
												tenure for a particular amount
												of loan.
											</>
										}
									/>
									<Accordion
										title="How does the loan repayment will be initiated?"
										content={
											<>
												Your EMI amount will get
												deducted from the account basis
												the setup done at the time of
												eNACH mandate registration
											</>
										}
									/>
									<Accordion
										title="How do I contact for any queries?"
										content={
											<>
												In case of any query, please
												reach out to us at
												Care.digitalfinance@adityabirlacapital.com
												with the application reference
												number.
											</>
										}
									/>
								</>
							}
						/>
					</div>
					<div className="index-cta">
						<Button
							id="cta-button"
							className="cta-button"
							onClick={() => {
								// history.push({
								//   pathname: `/login`,
								//   search: location.search,
								// });
								var route = getRouteFromLoanStageService({
									source: source,
									stage: "",
								});
								// console.log("stage: ", customerDetails.stage);
								// console.log("route: ", route);
								if (urlParams) {
									const url = `${route}${urlParams}`;
									navigate(url, {
										replace: true,
										// state: {
										// 	customerDetails: customerDetails,
										// },
									});
								} else {
									const url = `${route}`;
									navigate(url, {
										replace: true,
										// state: {
										// 	customerDetails: customerDetails,
										// },
									});
								}
							}}
							text={"Get an Instant Personal Loan"}
							style={{
								width: "100%",
							}}
						/>
					</div>
				</div>
			</LandingPageWrapper>
		</>
  );
};

export default EPL;
